window.bannerImageHandler = () => {
  document.addEventListener('DOMContentLoaded', () => setProportions());
  window.addEventListener('resize', () => setProportions());

  const setProportions = () => {
    const backgrounds = document.querySelectorAll('.jsBackgroundImage4x3');

    backgrounds.forEach(background => {
      if (window.innerWidth <= window.gridBreakpoints.sm)
        setImageProportions(background, 4, 3, 'y-position')
      else
        background.removeAttribute('style')
    });
  };
};
